<template>
    <div style="text-align:right">
      <span>
        <!--  {{ value ? Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 2,}).format(value) : 0 }} -->
        {{ Number(Number(getValue()).toFixed(decimalLength||decimalPlace[field]||decimalPlace.all)).toLocaleString('ja-JP', { minimumFractionDigits:(decimalLength||decimalPlace[field]||decimalPlace.all) }) }}
      </span>
    </div>
  </template>
  <script>
  export default {
    props: ['row','nested_key','ex_field','decimalLength','decimalPlace'],
    mounted(){
        //console.log("dp",this.decimalPlace.all)
        if(this.decimalLength)
        this.$set(this.decimalPlace, this.ex_field, this.decimalLength)
    },
    methods: {
        getValue(){
            let nested = this.nested_key.split('.');
            if(this.row[nested[0]].hasOwnProperty(nested[1])){
                return this.row[nested[0]][nested[1]]
            }
            
            return 0;
        }
    },
  }
  </script>
  <style>
  .-td-color-comp {
    width: 50px;
    height: 20px;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    line-height: 20px;
  }
  </style>
  